import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import Person from "../Person";

export default class CrmForm extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            teamId: props.TeamId,
            caller: props.Caller,
            data: null,
            loading: true,
            innerStatus: 0,
            sources: []
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/crm/case/get", {
            id: this.getCurrentFormId(),
            teamId: this.state.teamId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
            });
        var p2 = this.httpPost("api/v1/crm/source/list", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.sources = data.records;
                }
            });
        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            })
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/crm/case/save", {
            id: this.state.id,
            crmTeamId: this.state.teamId,
            kartablUserId: this.state.data.record.KartablUserId,
            sourceId: this.state.data.record.sourceId,
            personId: this.state.data.record.personId,
            crmCaseStatusId: this.state.data.record.crmCaseStatusId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPerson(e) {
        if (e.value == -1) {
            this.state.data.record.personId = this.defaultGuid();
            this.state.data.record.personName = '';
            this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
            return;
        }

        this.state.data.record.personId = e.value;
        this.state.data.record.personName = e.label;
        this.setState({
            data: this.state.data
        });
    }
    setCrmCaseStatus(e) {
        this.state.data.record.crmCaseStatusId = e.value;
        this.state.data.record.crmCaseStatusName = e.label;
        this.setState({
            data: this.state.data
        });
    }    
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات پیگیری" : "افزودن پیگیری جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">
                                                <em className="icon ni ni-plus hand ms-1" onClick={e => this.setPerson({ value: -1 })}></em>
                                                شخص:
                                            </label>
                                            <SelectAsync
                                                value={this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب شخص"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, 0)}
                                                onChange={e => this.setPerson(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">سرنخ</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.sourceId} onChange={e => this.state.data.record.sourceId = e.target.value} className="form-control input-sm">
                                                <option value={this.getDefaultGuid()}>فاقد سرنخ</option>
                                                {this.state.sources.map(cat => <option value={cat.id}>{cat.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">وضعیت:</label>
                                            <SelectAsync
                                                value={this.state.data.record.crmCaseStatusId != this.defaultGuid() ? [{ value: this.state.data.record.crmCaseStatusId, label: this.state.data.record.crmCaseStatusName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب وضعیت"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadCrmCaseStatusOptions(inputValue, callback, this.state.teamId)}
                                                onChange={e => this.setCrmCaseStatus(e)}
                                            />
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}